import $ from 'jquery';

$(function () {


});
